import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// import Img from 'gatsby-image';
import Link from 'gatsby-link';
import { AnimatedElement } from '../../animated-element';
import { getViewport, generateImageUrl } from '../../../utils/webp';
import { BlueButton, BlueButtonExternal } from '../../../utils/atoms';

import {
  Container,
  Content,
  Title,
  ArticleImg,
  Author,
  Date,
} from '../styles/featured-article.style';

const defaultProps = {
  data: {
    landscapeImage: {
      file: {},
    },
    description: { childMarkdownRemark: {} },
  },
};

const propTypes = {
  data: PropTypes.object,
};

/**
 * Featured Article Component
 */
class Article extends React.Component {
  /**
   *
   * @param {*} props Passed from parent component
   */
  constructor(props) {
    super(props);
    this.state = {
      mounted: false,
      viewportWidth: 2400,
    };
  }

  /**
   * Set viewport width on mount
   */
  componentWillMount() {
    if (typeof window !== 'undefined' && window) {
      this.setState({ viewportWidth: getViewport() });
    }
  }

  /**
   * Determine if mobile components should be used
   */
  componentDidMount() {
    this.setState({ mounted: true });
  }

  /**
   * Renders Component
   * @returns {*} component JSX
   */
  render() {
    const {
      data: {
        articleSlug,
        externalUrl,
        landscapeImage,
        title,
        source,
        date,
        updatedAt,
        childContentfulNewsArticleArticleSummaryTextNode,
      },
    } = this.props;
    const { mounted, viewportWidth } = this.state;
    let displayDate = moment(date).format('MMMM YYYY');
    if (!date) {
      displayDate = moment(updatedAt).format('Mo YYYY');
    }
    let src = '';
    if (landscapeImage && landscapeImage.file) {
      src = landscapeImage;
    }
    const bkgd = generateImageUrl(src && src.file && src.file.url, viewportWidth);
    const text = childContentfulNewsArticleArticleSummaryTextNode;

    if (mounted) {
      const mobileContent = (
        <Container>
          <div>
            <img alt="" className="featured-img" src={bkgd} />
          </div>
          <Content>
            <Title>{title}</Title>
            <Author>{source}</Author>
            { '|' }
            <Date>{displayDate}</Date>
          </Content>
        </Container>
      );

      const mobileContainer = externalUrl ? (
        <a href={externalUrl} className="mobile-only">
          {mobileContent}
        </a>
      ) : (
        <Link to={`/articles/${articleSlug}`} className="mobile-only">
          {mobileContent}
        </Link>
      );

      return (
        <div>
          {mobileContainer}
          <div className="desktop-only">
            <AnimatedElement data={{ image: src }} animationType="PARALLAX">
              <Container>
                <ArticleImg src={bkgd} />
                <Content>
                  <Title>{title}</Title>
                  <Author>{source}</Author>
                  { '|' }
                  <Date>{displayDate}</Date>
                  <p>{text && text.childMarkdownRemark ? text.childMarkdownRemark.excerpt : ''}</p>
                  {externalUrl ? (
                    <BlueButtonExternal className="link-external" href={externalUrl} target="_blank">
                      <span>Read More</span>
                    </BlueButtonExternal>
                  ) : (
                    <BlueButton className="link-internal" to={`/articles/${articleSlug}`}>
                      <span>Read More</span>
                    </BlueButton>
                  )}
                </Content>
              </Container>
            </AnimatedElement>
          </div>
        </div>
      );
    }
    return '';
  }
}

Article.propTypes = propTypes;
Article.defaultProps = defaultProps;

export default Article;



// WEBPACK FOOTER //
// ./src/components/featured-article/components/featured-article.js